import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTagsList } from "../../../../actions/client-action";
import TagsList from "./TagsList";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import { httpPost, httpPut, httpDelete } from "../../../../utility/requestHelper";
import { TagNameModal } from "./TagNameModal";
import { APP_CONSTANTS,COOKIE } from "../../../../constants/app-constant";
import { ConfirmModal } from "../../../Shared/Modal/ConfirmModal";
import Loader from "../../../Shared/Loader";
import ReactGA from "react-ga4";
import { getCookie } from "../../../../utility/cookieProvider";
import {GACODE} from "../../../../constants/app-constant";

export function Tags({ showAddTagModal, setShowAddTagModal }) {
  ReactGA.initialize(GACODE);

  const NAME_REQUIRED = "Tag name is required"
  const [loader, setLoader] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [tagNameStatus, setTagNameStatus] = useState("");
  const [tagsList, setTagsList] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editData, setEditId] = useState({
    editId,
    name,
  });
  const [error, setError] = useState(null)
  const dispatch = useDispatch();
  const { selectedClient, feedTagList } =
    useSelector(
      (state) => state.clientReducer
    ) || {};

  useEffect(() => {
    if (feedTagList) {
      const { data, isLoading, error } = feedTagList;
      setLoader(isLoading);
      setError(error);
      setTagsList(data)
    }
  }, [feedTagList]);

  useEffect(() => {
    // Reset error text when popup closes.
    if (!editModal && !showAddTagModal) {
      setTagNameStatus("")
    }
  }, [editModal, showAddTagModal]);

  const { editId, name } = editData;
  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.set({ userId: selectedClient.id+".0."+concept_uid });
    ReactGA.set({ 'user_id': selectedClient.id+".0."+concept_uid });
  }

  let locationHrefNew = window.location.href;
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.event({
      category: "Tags",
      action: "Tags - "+selectedClient.id+".0."+concept_uid,
      label: locationHrefNew, // optional
      //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
    });
  }

  const createTag = (name) => {
    setTagNameStatus("");
    if (name.trim()) {
      setModalLoader(true);
      httpPost(
        `${unifiedEnvConfig.CREATE_TAG}?client_id=${selectedClient.id}`,
        {
          name,
        }, {}, true
      )
        .then((response) => {
          if (response.data.status === 201) {
            dispatch(fetchTagsList(selectedClient.id));
            setTagNameStatus("");
            setModalLoader(false);
            setShowAddTagModal(false);
          }
        })
        .catch((err) => {
          setShowAddTagModal(true);
          handleTagNameError(err);
        });
    } else {
      setTagNameStatus(NAME_REQUIRED);
    }
  };

  const onModalCancel = () => {
    setShowAddTagModal(false)
    setEditModal(false);
    setDeleteModal(false);
  };


  const handleTagNameError = (error) => {
    try {
      setModalLoader(false);
      if (error.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
        setTagNameStatus("Tag already exists");
      } else {
        const {
          data: {
            status
          }
        } = error.response
        if (status == 409) {
          setTagNameStatus("Tag already exists");
        } else {
          setTagNameStatus("Error occurred. Please try again.");
        }
      }
    }
    catch (e) {
      setTagNameStatus("Error occurred. Please try again.");
    }
  };

  const onConfirmEditTagName = (name) => {
    if (name) {
      setModalLoader(true);
      httpPut(
        `${unifiedEnvConfig.EDIT_TAG_NAME
          .replace("{id}", editId)
          .replace("{client_id}", selectedClient.id)}`,
        {
          name,
        }, {}, true
      )
        .then((response) => {
          setModalLoader(false);
          if (response.data.status === 200) {
            setEditModal(false);
            setTagNameStatus("");
            dispatch(fetchTagsList(selectedClient.id));
          }
        })
        .catch((err) => {
          setEditModal(true);
          handleTagNameError(err);
        });
    } else {
      setTagNameStatus(NAME_REQUIRED);
    }
  };

  const onConfirmDeleteTag = () => {
    setModalLoader(true);
    httpDelete(
      `${unifiedEnvConfig.DELETE_TAG
        .replace("{id}", editId)
        .replace("{client_id}", selectedClient.id)}`
    )
      .then((response) => {
        if (response.status === 204) {
          dispatch(fetchTagsList(selectedClient.id));;
          setTimeout(() => setDeleteModal(false), 500)
        }
      })
      .catch((err) => {
        console.log(err.response.data);
        setTagNameStatus("Error occurred. Please try again.");
      })
      .finally(() => setModalLoader(false));
  };

  return (
    <>
      {
        loader ?
          <Loader />
          :
          <TagsList
            setEditModal={setEditModal}
            setDeleteModal={setDeleteModal}
            setEditId={setEditId}
            tagsList={tagsList}
          />
      }
      {
        showAddTagModal ?
          <TagNameModal
            show={showAddTagModal}
            onCancel={onModalCancel}
            modalTitle="Add Tag"
            confirmButtonText="Add Tag"
            onConfirm={createTag}
            error={tagNameStatus}
            modalLoader={modalLoader}
          />
          : null
      }
      {
        editModal ? (
          <TagNameModal
            show={editModal}
            onCancel={onModalCancel}
            modalTitle="Edit Name"
            confirmButtonText="Update"
            onConfirm={onConfirmEditTagName}
            error={tagNameStatus}
            confirmText="Edit name for dashboard"
            editValue={editData}
            modalLoader={modalLoader}
          />
        ) : null
      }

      {
        deleteModal ? (
          <ConfirmModal
            show={deleteModal}
            onCancel={onModalCancel}
            modalTitle="Delete Dashboard"
            confirmButtonText="Delete"
            confirmText="Are you sure you want to delete this Dashboard?"
            onConfirm={onConfirmDeleteTag}
            isLoading={modalLoader}
            disableSubmit={modalLoader}
          />
        ) : null
      }
    </>
  );
};
